import React, { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Column } from "primereact/column";
import EditAddForm from "./edit-add-form";
import Spinner from "../../components/spinner";
import { axiosApi } from "../../../services/axios_api";
import { toast } from "react-toastify";
import editIcon from "../../../../assets/assests/edit.png";
import Dots from "../../../../assets/assests/detail.png";
import deleteIcon from "../../../../assets/assests/delete.png";
import { Tag } from "primereact/tag";
import { confirmDialog } from "primereact/confirmdialog";
import PaginatorComponent from "../../components/paginator";
import useDebounce from "../../components/hooks/useDebounce";
import { exportToExcel } from "../../components/helper";
import Details from "./details-user";

export default function UserManagementScreen({
  showDialog,
  setShowDialog,
  isEdit,
  setIsEdit,
  selectedData,
  globalFilter,
  exportCSV,
  statusFilter,
  roleFilter,
  setRoles,
}) {
  const [res, setRes] = useState([]);
  const [rowselect, setRowselect] = useState(null);
  const [showdetail, setShowdetail] = useState(false);
  const [editable, setEditable] = useState();
  const [loading, setLoading] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  
  const debouncedSearch = useDebounce(globalFilter, 500);

  useEffect(() => {
    const fetchRoles = async () => {
      setLoading(true);
      try {
        const response = await axiosApi.get(`/Portal/lists/roles`);
        setRoles(response.data.body || []);
      } catch (error) {
        toast.error("Failed to fetch roles data.");
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, []);

  const getUsersData = async (pageNumber = 1, pageSize = rows) => {
    setLoading(true);
    try {
      const response = await axiosApi.get(`/Portal/users/get-all-paginated`, {
        params: {
          pageNumber,
          pageSize,
          searchTerm: debouncedSearch || "",
          roleId: roleFilter || "",
          isActive: statusFilter ? statusFilter === "Active" : undefined,
        },
      });
      setFilteredList(response.data.body);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event) => {
    const { first, rows } = event;
    setFirst(first);
    setRows(rows);
    const pageNumber = first / rows + 1;
    getUsersData(pageNumber, rows);
  };

  useEffect(() => {
    getUsersData();
  }, [debouncedSearch, statusFilter, roleFilter,res]);

  const onHide = () => {
    setShowDialog(false);
  };

  const editAction = (rowData) => {
    setEditable(true);
    setIsEdit(true);
    setRowselect(rowData);
    setShowDialog(true);
  };

  const accept = async (rowData) => {
    try {
      const response = await axiosApi.delete(
        `/Portal/users/delete?userId=${rowData.id}`
      );

      setRes(response.data);
      toast.success("Deleted Successfully");
      onHide();
    } catch (error) {
      toast.error("Failed to delete. Please try again.");
      console.error("Error deleting disclaimer:", error);
    }
  };
  const reject = () => { };

  const confirm = (rowData) => {
    confirmDialog({
      message: "Are you sure you want to delete this user?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      accept: () => accept(rowData),
      reject: () => reject(),
      acceptClassName: "custom-btn-red",
      rejectClassName: "custom-white-red",
      className: "center-buttons no-close-button",
    });
  };

  const toggleStatus = (rowData) => {
    confirmDialog({
      header: "User Status Confirmation",
      icon: "pi pi-info-circle",
      message: `Are you sure you want to ${rowData.isActive ? "deactivate" : "activate"
        } this user?`,
      accept: async () => {
        try {
          const response = await axiosApi.get(
            `/Portal/users/toggle-is-active?userId=${rowData.id}`
          );

          const updatedUsers = filteredList.map((user) =>
            user.id === rowData.id
              ? { ...user, isActive: !rowData.isActive }
              : user
          );
          setFilteredList(updatedUsers);

          toast.success(
            `User ${rowData.isActive ? "deactivated" : "activated"
            } successfully`
          );
          setRes(response);
     
        } catch (error) {
          console.error("Error updating user status:", error);
          toast.error("Failed to update user status");
        }
      },
      reject: () => { },
    });
  };
  const showDetails = (rowData) => {
    setRowselect(rowData);
    setShowdetail(true);
  }

  const actionTemplate = (rowData) => {
    const isActive = rowData?.isActive;
    return (
      <div className="action-buttons">
        <Button
          className=" p-button-edit p-0 mr-3"
          onClick={() => {
            editAction(rowData);
          }}
          aria-label="Edit"
        >
          <img src={editIcon} alt="Edit" />
        </Button>
        <div
          className={`toggle-switch ${isActive ? "active" : "inactive"}`}
          onClick={() => toggleStatus(rowData)}
        >
          <div className={`toggle-knob ${isActive ? "active" : "inactive"}`} />
        </div>
        <Button
          className=" p-button-edit p-0 mr-3"
          onClick={() => {
            confirm(rowData);
          }}
        >
          <img src={deleteIcon} alt="Delete" />
        </Button>
        <Button className="p-button-edit p-0 mr-3" onClick={() => showDetails(rowData)}>
          <img src={Dots} alt="Details" />
        </Button>

      </div>
    );
  };

  const columnsData = [
   
    {
      field: "name",
      header: "Name",
      body: (rowData) => rowData.name || "--",
      frozen: true,
    },
    {
      field: "username",
      header: "User Name",
      body: (rowData) => rowData.username || "--",
      frozen: true,
    },
    {
      field: "branchName",
      header: "Branch Name",
      body: (rowData) => rowData.branchName || "--",
    },
    {
      field: "email",
      header: "Email",
      body: (rowData) => rowData.email || "--",
    },
    {
      field: "mobileNumber",
      header: "Mobile Number",
      body: (rowData) => rowData.mobileNumber || "--",
    },
    {
      field: "alertPreferences",
      header: "alertPreferences",
      body: (rowData) => rowData.alertPreferences || "--",
    },
    {
      field: "roleName",
      header: "Role",
      body: (rowData) => rowData.roleName || "--",
    },
    {
      field: "isActive",
      header: "Status",
      body: (rowData) =>
        rowData.isActive !== null ? (
          rowData.isActive ? (
            <Tag className="custom-success-tag" value="Active" />
          ) : (
            <Tag className="custom-danger-tag" value="In-Active" />
          )
        ) : (
          "--"
        ),
    },
    {
      header: "Action",
      body: actionTemplate,
    },
  ];

  const exportCSVHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(`/Portal/users/get-all`);
      exportToExcel(response.data.body, columnsData, "UsersData");
    } catch (error) {
      toast.error("Failed to export data.");
      console.error("Export Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (exportCSV) {
      exportCSV.current = exportCSVHandler;
    }
  }, []);

  return (
    <>
      <Dialog
        header={
          <div className="popup-header">
            <div className="popup-header-text">
              {isEdit ? "Edit User" : "Add New User"}
            </div>
          </div>
        }
        visible={showDialog}
        onHide={onHide}
        className="dialog-size"
      >
        <EditAddForm
          rowData={isEdit ? rowselect : null}
          setShowDialog={setShowDialog}
          getUsersData={getUsersData}
          showDialog={showDialog}
          editable={editable}
          onHide={onHide}
          formData={isEdit ? selectedData : null}
          setRes={setRes}
        />
      </Dialog>
      <Dialog
        visible={showdetail}
        onHide={() => setShowdetail(false)}
        header="User Details"
       className="dialog-size"
      >
        <Details
                  rowData={ rowselect } />
      </Dialog>

      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}

      <div className="card card-container">
        <DataTable
          emptyMessage="No record found."
          value={filteredList}
          className="custom-data-table"
          scrollable
          globalFilter={globalFilter}
        >
          {columnsData.map((data, index) => (
            <Column
              key={index}
              field={data.field}
              header={data.header}
              body={data.body}
              frozen={data.frozen}
            />
          ))}
        </DataTable>
        {totalRecords > 0 && (
          <PaginatorComponent
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
}
